import { render, staticRenderFns } from "./BreadcrumbsList.vue?vue&type=template&id=da347ecc&"
import script from "./BreadcrumbsList.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BreadcrumbsList.vue"
export default component.exports